import { updatePolicyType } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { policyTypeData } from "../types/PolicyTypeInterface";

const useUpdatePolicyType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (PolicyTypeNewData: policyTypeData) => updatePolicyType(PolicyTypeNewData),
    {
      onSuccess: (res: any) => {
        if (res.data === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetPolicyType"]);
          toast.fire("Success", "Policy Type Updated Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Saving Failed", "Failed to Update Policy Type!", "error");
      },
    }
  );
  return mutate;
};
export default useUpdatePolicyType;
